<template>
  <div class="contactUs">
    <banner/>
    <div class="contactContent">
      <el-row class="contactMap" type="flex">
        <el-col :lg="16" :md="20">
          <div class="map">
            <h5>南京迪孚网络科技有限公司</h5>
            <baidu-map
              :center="center"
              :zoom="zoom"
              @ready="handler"
              style="height:5rem; font-size:0.26rem;"
              @click="getClickInfo"
              :scroll-wheel-zoom="true"
            >
              <bm-info-window
                style="width:5rem;"
                :position="center"
                title="南京迪孚网络科技有限公司"
                :show="infoWindow.show"
              >
                <p v-text="infoWindow.contents"></p>
              </bm-info-window>
            </baidu-map>
            <div class="address">
              <div class="addressL">
                 <p>
                  <span class="A_title">地址：</span>
                  <span>南京市江宁区东山街道丰泽路</span>
                </p>
                <p>
                  <span class="A_title">咨询：</span>
                  <span>13813359066 （工作日9:00—18:00）</span>
                </p>
                <p>
                  <span class="A_title">邮箱：</span>
                  <span>market@njdifu.com</span>
                </p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import banner from '@/mobile/components/banner'
export default {
  name: 'JoinUs',
  components: {
    banner
  },
  data () {
    return {
      center: { lng: 118.886634, lat: 31.999301 },
      infoWindow: {
        show: true,
        contents: '南京市江宁区东山街道丰泽路'
      },
      zoom: 16
    }
  },
  methods: {

    handler ({ BMap, map }) {
      let that = this
      that.infoWindow.show = true
      var point = new BMap.Point(118.886634, 31.999301)
      map.centerAndZoom(point, 16)
      var marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
      // var circle = new BMap.Circle(point, 6, {
      //   strokeColor: 'Red',
      //   strokeWeight: 6,
      //   strokeOpacity: 1,
      //   Color: 'Red',
      //   fillColor: '#f03'
      // })
      // map.addOverlay(circle)
      // 标注的点击事件
      // marker.addEventListener('click', function (event) {
      //   console.log('--------------event', event.point.lng)
      //   // that.infoWindow.show = true
      //   that.center.lng = event.point.lng
      //   that.center.lat = event.point.lat
      // })
    },
    getClickInfo (e) {
      console.log(e.point.lng)
      console.log(e.point.lat)
      // this.center.lng = e.point.lng
      // this.center.lat = e.point.lat
    }
  }
}
</script>
<style lang="scss" scoped>
.contactUs {
  margin-top: 0.8rem;
  .banner{
    overflow: hidden;
    img{
      height:3.26rem;
    }
  }
  .title1 {
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    h3 {
      color: #0355a4;
    }
    .selectOption {
      margin-top: 40px;
    }
  }
  .contactContent {
    .contactMap {
      background: #fff;
      padding: 0.6rem 0.3rem;
      justify-content: center;
      .map {
        background: #fff;
        padding: 0.3rem;
        padding-top: 0;
        border: 1px solid #ccc;
        h5 {
          font-size: 0.34rem;
          padding: 0.3rem 0;
          text-align: left;
        }
        .boxMap {
          width: 100%;
        }
        .address {
          padding: 0.4rem 0;
          .addressL {
            p {
              font-size: 0.3rem;
              line-height: 0.5rem;
              text-align: left;
              .A_title{
                font-weight: bold;
              }
            }
          }
          .addressR {
            img {
              width: 3rem;
            }
          }
        }
      }
    }
    .contactWay {
      padding: 0.3rem;
      text-align: left;
      font-size:0.28rem;
      h6 {
        font-size:0.32rem;
        margin-bottom:0.1rem;
        font-weight:bold;
      }
      .center_phone {
        margin-bottom:0.16rem;
      }
    }
    .message {
      padding:0.3rem;
      justify-content: center;
      .messageCont {
        p {
          font-size:0.42rem;
          background: #fff;
          text-align:left;
        }
        ul {
          display: table;
          border-collapse: collapse;
          margin:0.3rem 0;
          li {
            display: table-cell;
            width:2.3rem;
            height:0.9rem;
            line-height:0.9rem;
            font-size:0.4rem;
            cursor: pointer;
            border: 1px solid #eee;
            .font1 {
            }
          }
        }
      }
    }
  }
}
</style>
